// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-p_fK","advertDetailParameterList__header":"c-p_fL","advertDetailParameterList__list":"c-p_fM"};